export function formatDataTestId(id: string) {
  return '-' + id.replace(/\s/g, '-').toLowerCase()
}
